import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const getAgents=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_AGENTS_START
    })
    await axios.get('/agents')
            .then(response=>dispatch({
                type:actionTypes.GET_AGENTS_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_AGENTS_FAIL,
                payload:getMessage(error)
            }))
}